import { PiggyBank } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import FeatureFlags from "../../common/feature-flagging/FeatureFlags";
import OdpLimitsPage from "./pages/OdpLimitsPage";
import SegmentationBlocksHistoryPage from "./pages/SegmentationBlocksHistoryPage";
import { FEATURE_ODP } from "../../utils/UserAccessControlUtils";

const OdpManagementRouter: NavigationLinkProps[] = [
  {
    id: "59828f20-c9ac-4c00-a420-562231946dd5",
    title: "Financial Benefits",
    description: "",
    path: "/financial-benefits",
    auth: true,
    sidebar: true,
    icon: PiggyBank,
    component: OdpLimitsPage,
    requiredFeature: FEATURE_ODP, // this is intentional, to let employer toggle feature (on/off) and for upselling odp
    requiredFeatureFlag: FeatureFlags.EMPLOYER_PORTAL_ODP_LIMITS_VIEW,
    isFeatureFlagged: true,
    requiredPermissions: ["ANY"],
  },
  {
    id: "b9f2e4a1-3c5d-4e8f-9a2b-1c6d7e8f9a0b",
    title: "Segmentation Blocks History",
    description: "",
    path: "/financial-benefits/segmentation-history",
    auth: true,
    sidebar: false,
    component: SegmentationBlocksHistoryPage,
    requiredFeature: FEATURE_ODP,
    requiredFeatureFlag: FeatureFlags.EMPLOYER_ODP_SEGMENTATION_BLOCKS,
    isFeatureFlagged: true,
    requiredPermissions: ["ANY"],
  },
];

export default OdpManagementRouter;
